import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AuthService} from "../services/auth/auth.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {
  }

  intercept(request: HttpRequest<any>, handler: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getBearer();

    if (!token) {
      return handler.handle(request);
    }

    const bearerRequest = request.clone({
      headers: request.headers.set('Authorization', `Bearer ${token}`),
    });

    return handler.handle(bearerRequest);
  }
}
